<template>
  <ux-form
    ref="form"
    width="450px"
    :data="formData"
    :colon="true"
    :rules="rules"
    data-automation="addApply"
    @close="close"
    @confirm="confirm"
    label-width="60px"
  >
    <ux-form-item :label="$t('HT.advancedService.quato')" required prop="quato">
      <el-input-number v-model="formData.quato"
        :maxlength="32"
        size="small"
        :max="data.quato"
        :min="1"
        :placeholder="$t('HT.pleaseInput')+$t('HT.advancedService.limit')"></el-input-number>
      <!-- <ux-input
        v-model="formData.quato"
        :maxlength="32"
        :placeholder="$t('HT.pleaseInput')+$t('HT.advancedService.limit')"
      ></ux-input> -->
    </ux-form-item>
    <div class="tip">{{ $t('HT.advancedService.quato.tip',{ num: data.quato}) }}</div>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          quato: '',
        };
      }
    }
  },

  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.addApply(),
    };
  },

  methods: {

    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.formData);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.tip {
  font-size: 12px;
  color: #999;
  margin-top: -20px;
  margin-left: 70px;
}
</style>